import { render, staticRenderFns } from "./TrailBlockSelection.vue?vue&type=template&id=bdbe5cf2"
import script from "./TrailBlockSelection.vue?vue&type=script&lang=js"
export * from "./TrailBlockSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports